module.exports = __webpack_public_path__ + "img/Freespin_h2.533540b1.png";